export class ServerCall{
    private static readonly API_URL = process.env.REACT_APP_API_URL

    public static get = <T>(url: string): Promise<T> => fetch(this.API_URL + url).then(res => res.json())
}